import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, vShow as _vShow, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, withKeys as _withKeys, Teleport as _Teleport, createBlock as _createBlock } from "vue"

import { computed, nextTick, ref, watch, type CSSProperties } from 'vue'
import { icons } from '@/plugins/icon'


export default /*#__PURE__*/_defineComponent({
  __name: 'Modal',
  props: {
    visible: { type: Boolean },
    width: { default: 480 },
    closeButton: { type: Boolean, default: false },
    closeOnClickMask: { type: Boolean, default: true },
    closeOnEsc: { type: Boolean, default: true },
    contentStyle: {}
  },
  emits: ["update:visible", "closed"],
  setup(__props: any, { emit: __emit }) {

const { IconClose } = icons

const props = __props

const modalRef = ref<HTMLDivElement>()

const emit = __emit

const contentVisible = ref(false)

const contentStyle = computed(() => {
  return {
    width: props.width + 'px',
    ...(props.contentStyle || {})
  }
})

watch(() => props.visible, () => {
  if (props.visible) {
    nextTick(() => modalRef.value!.focus())
  }
})

const close = () => {
  emit('update:visible', false)
  emit('closed')
}

const onEsc = () => {
  if (props.visible && props.closeOnEsc) close()
}

const onClickMask = () => {
  if (props.closeOnClickMask) close()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_Transition, { name: "modal-fade" }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", {
          class: "modal",
          ref_key: "modalRef",
          ref: modalRef,
          tabindex: "-1",
          onKeyup: _cache[4] || (_cache[4] = _withKeys(($event: any) => (onEsc()), ["esc"]))
        }, [
          _createElementVNode("div", {
            class: "mask",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (onClickMask()))
          }),
          _createVNode(_Transition, {
            name: "modal-zoom",
            onAfterLeave: _cache[2] || (_cache[2] = ($event: any) => (contentVisible.value = false)),
            onBeforeEnter: _cache[3] || (_cache[3] = ($event: any) => (contentVisible.value = true))
          }, {
            default: _withCtx(() => [
              _withDirectives(_createElementVNode("div", {
                class: "modal-content",
                style: _normalizeStyle(contentStyle.value)
              }, [
                (_ctx.closeButton)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      class: "close-btn",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (close()))
                    }, [
                      _createVNode(_unref(IconClose))
                    ]))
                  : _createCommentVNode("", true),
                (contentVisible.value)
                  ? _renderSlot(_ctx.$slots, "default", { key: 1 })
                  : _createCommentVNode("", true)
              ], 4), [
                [_vShow, _ctx.visible]
              ])
            ]),
            _: 3
          })
        ], 544), [
          [_vShow, _ctx.visible]
        ])
      ]),
      _: 3
    })
  ]))
}
}

})